import { env } from "~/env.mjs";

const useSendFile = (setMessageResponce) => {
  const SendFile = async (
    nameSurname: string,
    email: string,
    phoneNumber: string,
    message: string,
    fileEsperienza: File,
    idForm: string
  ) => {
    const body = new FormData();
    body.append("nome", nameSurname);
    body.append("email", email);
    body.append("telefono", phoneNumber);
    body.append("messaggio", message);
    body.append("fileEsperienza", fileEsperienza);
    body.append("privacy", "informativa privacy accettata");
    body.append("_wpcf7_unit_tag", "wpcf7-f20-o1");
    fetch(
      `${env.NEXT_PUBLIC_WORDPRESS_BASEPATH}/wp-json/contact-form-7/v1/contact-forms/${idForm}/feedback `,
      {
        method: "POST",
        body: body,
      }
    )
      .then((data) => {
        if (data.status == 200) {
          setMessageResponce(
            "Grazie! Il tuo messaggio è stato inviato con successo. Ti contatteremo il prima possibile"
          );
          return true;
        }
        if (data.status == 400) {
          setMessageResponce(
            "Ci dispiace! Si è verificato un errore durante l'invio del tuo messaggio. Riprova più tardi"
          );
          return false;
        }
      })
      .catch((error) => {
        console.error(error);
        return false;
      });
  };
  return { SendFile };
};

export default useSendFile;
